// Shared dashboard validation points for job, contract and project dashboards.
export const DASHBOARD_VALIDATION_TITLE = "Dashboard stats unavailable";

// Priority order: allocation first (billable hours depend on it).
export const DASHBOARD_VALIDATION_CHECKS = [
  {
    key: "hasAllocation",
    message: "Add an allocation to see hours and progress.",
    cta: {
      job: (id) => ({
        label: "Configure allocation",
        to: `/work/jobs/${id}/allocation`,
      }),
      // Allocation is configured per job.
      contract: (id) => ({
        label: "Configure allocation in jobs",
        to: `/work/contracts/${id}/jobs`,
      }),
      // Allocation is configured per job; id is the project slug.
      project: (slug) => ({
        label: "Configure allocation in jobs",
        to: `/work/projects/${slug}/jobs`,
      }),
    },
  },
  {
    key: "hasBillableHours",
    message: "Add billable hours in milestones to calculate revenue and margin.",
    cta: {
      job: (id) => ({
        label: "Configure milestones",
        to: `/work/jobs/${id}/milestones`,
      }),
      // Contracts have no milestones page; milestones are configured per job.
      contract: (id) => ({
        label: "Add milestones in jobs",
        to: `/work/contracts/${id}/jobs`,
      }),
      // Project milestones page; id is the project slug.
      project: (slug) => ({
        label: "Configure milestones",
        to: `/work/projects/${slug}/milestones`,
      }),
    },
  },
];

/**
 * All failing checks (validation[key] === false) in priority order.
 * @param {object} validation
 * @param {"job"|"contract"|"project"} context
 * @param {string} id jobId / contractId / project slug
 * @returns {{key: string, message: string, cta?: {label: string, to: string}}[]}
 */
export const getDashboardValidationIssues = (validation, context, id) =>
  DASHBOARD_VALIDATION_CHECKS.filter((c) => validation?.[c.key] === false).map(
    (c) => ({ key: c.key, message: c.message, cta: c.cta[context]?.(id) }),
  );
